import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { Distance } from '../models';

import {
  getButtonText,
  getDistances,
  getFacilities,
  getMainDescription,
  getTagsUrls,
  getOpeningParagraph,
} from './activityDetailsDescriptionStoreLogic';
import { useActivityDetailsStore } from './activityDetailsStore';

const DEFAULT_SHOW_FULL_DESCRIPTION = false;

export const useActivityDetailsDescriptionStore = defineStore(
  'ActivityDestailsDescriptionStore',
  () => {
    const activityDetailsStore = useActivityDetailsStore();

    // State
    const showFullDescription = ref<boolean>(DEFAULT_SHOW_FULL_DESCRIPTION);

    // Actions
    function toggleFullDescription(): void {
      showFullDescription.value = !showFullDescription.value;
    }
    // Getters

    const buttonText = computed<string>(() =>
      getButtonText(showFullDescription.value)
    );

    const distances = computed<Distance[] | undefined>(() =>
      getDistances(activityDetailsStore.activityDetails)
    );

    const facilities = computed<string[] | undefined>(() =>
      getFacilities(activityDetailsStore.activityDetails)
    );

    const mainDescription = computed<string | undefined>(() =>
      getMainDescription(
        activityDetailsStore.activityDetails,
        showFullDescription.value,
        tagsUrls.value,
        {
          tagsEquivalent: 40,
          toFillSpaceNextToMap: 700,
        }
      )
    );

    const openingParagraph = computed<string | undefined>(() =>
      getOpeningParagraph(activityDetailsStore.activityDetails)
    );

    const tagsUrls = computed<string[] | undefined>(() =>
      getTagsUrls(activityDetailsStore.activityDetails)
    );

    return {
      // Getters
      buttonText,
      distances,
      facilities,
      mainDescription,
      openingParagraph,
      tagsUrls,

      // Actions
      toggleFullDescription,
    };
  }
);
